module.exports = __webpack_public_path__ + "img/logo.f0bdd766.png";